import dayjs from "dayjs";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";

import { toast, ToastContainer } from "react-toastify";

import { DashboardContext } from "context/Context";

export default function Month({ month, data, callbackFn, selectedLocation, businessLocations }) {
  const { user, company, setCompany } = useContext(DashboardContext);

  const [daySelected, setDaySelected] = useState({
    day: 0,
    month: 0,
    year: 2023,
    date: new Date(),
  });
  const [showModal, setShowEventModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [magnaCost, setMagnaCost] = useState(0);
  const [premiumCost, setPremiumCost] = useState(0);
  const [dieselCost, setDieselCost] = useState(0);
  const [bulkMode, setBulkMode] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [cloneTargets, setCloneTargets] = useState([]);
  const [cloning, setCloning] = useState(false);

  const db = getFirestore();

  // const { setDaySelected, setShowEventModal, filteredEvents, setSelectedEvent } =
  //   useContext(GlobalContext);
  // useEffect(() => {
  //   const events = filteredEvents.filter(
  //     (evt) => dayjs(evt.day).format("DD-MM-YY") === day.format("DD-MM-YY")
  //   );
  //   // setDayEvents(events);
  // }, []);

  const updateGasCosts = async (date) => {
    setLoading(true);

    try {
      const dates = [];
      if (bulkMode && endDate) {
        let cursor = dayjs(daySelected.date).startOf("day");
        const end = dayjs(endDate).startOf("day");
        while (cursor.isBefore(end) || cursor.isSame(end, "day")) {
          dates.push(cursor);
          cursor = cursor.add(1, "day");
        }
      } else {
        dates.push(dayjs(date));
      }

      const costPayload = {
        magnaCost: magnaCost ? Number(magnaCost) : 0,
        premiumCost: premiumCost ? Number(premiumCost) : 0,
        dieselCost: dieselCost ? Number(dieselCost) : 0,
      };

      for (const d of dates) {
        const dateString = d.format("DD-MM-YYYY");
        await setDoc(
          doc(db, "companies", user.companyId, "dayInformation", dateString),
          {
            date: d.toDate(),
            dateDay: d.date(),
            dateMonth: d.month() + 1,
            dateYear: d.year(),
            [selectedLocation?.locId]: costPayload,
          },
          { merge: true }
        );
      }

      setLoading(false);
      setShowEventModal(false);
      callbackFn(true);
      setMagnaCost(0);
      setPremiumCost(0);
      setDieselCost(0);
      setBulkMode(false);
      setEndDate("");
      setCloneTargets([]);
      toast.success(
        dates.length > 1
          ? `Costos actualizados para ${dates.length} días`
          : "Costos actualizados correctamente"
      );
    } catch (er) {
      setLoading(false);
      toast.error(er.message);
    }
  };

  const cloneCostsToStations = async () => {
    if (!selectedLocation?.locId) {
      toast.error("Selecciona una estación origen");
      return;
    }
    if (cloneTargets.length === 0) {
      toast.error("Selecciona al menos una estación destino");
      return;
    }

    setCloning(true);
    try {
      const dates = [];
      if (bulkMode && endDate) {
        let cursor = dayjs(daySelected.date).startOf("day");
        const end = dayjs(endDate).startOf("day");
        while (cursor.isBefore(end) || cursor.isSame(end, "day")) {
          dates.push(cursor);
          cursor = cursor.add(1, "day");
        }
      } else {
        dates.push(dayjs(daySelected.date));
      }

      const costPayload = {
        magnaCost: magnaCost ? Number(magnaCost) : 0,
        premiumCost: premiumCost ? Number(premiumCost) : 0,
        dieselCost: dieselCost ? Number(dieselCost) : 0,
      };

      for (const d of dates) {
        const dateString = d.format("DD-MM-YYYY");
        const payload = {
          date: d.toDate(),
          dateDay: d.date(),
          dateMonth: d.month() + 1,
          dateYear: d.year(),
        };
        cloneTargets.forEach((locId) => {
          payload[locId] = costPayload;
        });
        await setDoc(
          doc(db, "companies", user.companyId, "dayInformation", dateString),
          payload,
          { merge: true }
        );
      }

      setCloning(false);
      setShowEventModal(false);
      callbackFn(true);
      setCloneTargets([]);
      const stationsLabel = cloneTargets.length === 1 ? "estación" : "estaciones";
      toast.success(
        dates.length > 1
          ? `Costos clonados a ${cloneTargets.length} ${stationsLabel} para ${dates.length} días`
          : `Costos clonados a ${cloneTargets.length} ${stationsLabel}`
      );
    } catch (er) {
      setCloning(false);
      toast.error(er.message);
    }
  };

  const toggleCloneTarget = (locId) => {
    setCloneTargets((prev) =>
      prev.includes(locId) ? prev.filter((id) => id !== locId) : [...prev, locId]
    );
  };

  const otherLocations = (businessLocations || []).filter(
    (loc) => loc.locId && loc.locId !== selectedLocation?.locId
  );

  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre 🇲🇽 🌮",
    "Octubre 👻 🎃",
    "Noviembre 🦃",
    "Diciembre 🎄🎅",
  ];

  const getDayEvents = (day) => {
    // Extract day, month, and year from the day parameter
    const targetDay = day.date();
    const targetMonth = day.month() + 1;
    const targetYear = day.year();

    const events = data.filter((evt) => {
      return evt.dateDay === targetDay && evt.dateMonth === targetMonth;
    });
    // console.log("targetDay: ", targetDay, " - targetMonth: ", targetMonth, "- events: ", events);

    return events;
  };

  const applyDaySelection = (dayObj) => {
    const jsDate = new Date(dayObj);
    const info = getDayEvents(dayjs(jsDate));

    setDaySelected({
      day: jsDate.getDate(),
      month: jsDate.getMonth(),
      year: jsDate.getFullYear(),
      date: jsDate,
    });

    if (info.length > 0) {
      setMagnaCost(info[0][selectedLocation?.locId]?.magnaCost || 0);
      setPremiumCost(info[0][selectedLocation?.locId]?.premiumCost || 0);
      setDieselCost(info[0][selectedLocation?.locId]?.dieselCost || 0);
    } else {
      setMagnaCost(0);
      setPremiumCost(0);
      setDieselCost(0);
    }
  };

  const shiftDay = (delta) => {
    const newDay = dayjs(daySelected.date).add(delta, "day");
    applyDaySelection(newDay);
  };

  function Day({ day, rowIdx }) {
    function getCurrentDayClass() {
      return day.format("DD-MM-YYYY") === dayjs().format("DD-MM-YYYY")
        ? "bg-primary text-white rounded py-1 fw-bold px-1"
        : "";
    }
    let dayInfo = getDayEvents(day);

    return (
      <div
        className="border border-gray-200 d-flex flex-column cursor-pointer calenday"
        onClick={() => {
          applyDaySelection(day);
          setShowEventModal(true);
        }}
      >
        <header className="d-flex flex-column items-center w-100">
          {rowIdx === 0 && (
            <p className="text-sm text-left" style={{ marginTop: "-2rem" }}>
              {day.format("ddd").toUpperCase()}
            </p>
          )}
          <div className="text-center">
            <p className={`p-1 my-1 text-center ${getCurrentDayClass()}`}>{day.format("DD")}</p>
          </div>
        </header>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-between">
              {dayInfo.length > 0 && (
                <div className="w-100">
                  <p className="m-0 text-center">Costos</p>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <small className="text-success p-0 m-0">
                      M:{" "}
                      {dayInfo[0][selectedLocation?.locId]?.magnaCost != null &&
                      dayInfo[0][selectedLocation?.locId]?.magnaCost != undefined ? (
                        <span>{dayInfo[0][selectedLocation?.locId]?.magnaCost}</span>
                      ) : (
                        <span>-</span>
                      )}
                    </small>
                    <small className="text-danger p-0 m-0">
                      P:{" "}
                      {dayInfo[0][selectedLocation?.locId]?.premiumCost != null &&
                      dayInfo[0][selectedLocation?.locId]?.premiumCost != undefined ? (
                        <span>{dayInfo[0][selectedLocation?.locId]?.premiumCost}</span>
                      ) : (
                        <span>-</span>
                      )}
                    </small>

                    <small className="text-black p-0 m-0">
                      D:{" "}
                      {dayInfo[0][selectedLocation?.locId]?.dieselCost != null &&
                      dayInfo[0][selectedLocation?.locId]?.dieselCost != undefined ? (
                        <span>{dayInfo[0][selectedLocation?.locId]?.dieselCost}</span>
                      ) : (
                        <span>-</span>
                      )}
                    </small>
                  </div>
                </div>
              )}

              {dayInfo.length > 0 && dayInfo[0][selectedLocation?.locId] && (
                <div className="w-100">
                  <p className="m-0 text-center">Precio Venta</p>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <small className="text-success p-0 m-0 r">
                      M: <span>{dayInfo[0][selectedLocation?.locId].magnaPrice}</span>
                    </small>

                    <small className="text-danger p-0 m-0">
                      P: <span>{dayInfo[0][selectedLocation?.locId].premiumPrice}</span>
                    </small>

                    <small className="text-black p-0 m-0">
                      D:{" "}
                      {dayInfo[0][selectedLocation?.locId]?.dieselPrice != null &&
                      dayInfo[0][selectedLocation?.locId]?.dieselPrice != undefined ? (
                        <span>{dayInfo[0][selectedLocation?.locId]?.dieselPrice}</span>
                      ) : (
                        <span>-</span>
                      )}
                    </small>
                  </div>
                </div>
              )}
            </div>

            {dayInfo.length > 0 && dayInfo[0][selectedLocation?.locId] && (
              <div className="w-100">
                <div className="d-flex justify-content-between">
                  <div className="w-100">
                    <p className="m-0 text-center">Ventas</p>
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <small className="text-success p-0 mx-1">
                        M:{" "}
                        <span>
                          ${" "}
                          {dayInfo[0][selectedLocation?.locId].magnaSalesIncome == undefined
                            ? 0
                            : dayInfo[0][
                                selectedLocation?.locId
                              ].magnaSalesIncome.toLocaleString() || 0}
                        </span>
                      </small>

                      <small className="text-danger p-0 mx-1">
                        P:{" "}
                        <span>
                          ${" "}
                          {dayInfo[0][selectedLocation?.locId].premiumSalesIncome == undefined
                            ? 0
                            : dayInfo[0][
                                selectedLocation?.locId
                              ].premiumSalesIncome.toLocaleString() || 0}
                        </span>
                      </small>

                      <small className="text-black p-0 mx-1">
                        D:{" "}
                        <span>
                          ${" "}
                          {dayInfo[0][selectedLocation?.locId].dieselSalesIncome == undefined
                            ? 0
                            : dayInfo[0][
                                selectedLocation?.locId
                              ].dieselSalesIncome.toLocaleString() || 0}
                        </span>
                      </small>
                    </div>
                  </div>

                  <div className="w-100">
                    <p className="text-center m-0">Litros</p>
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <small className="text-success p-0 mx-1">
                        M:{" "}
                        <span>
                          {dayInfo[0][selectedLocation?.locId].magnaLitersSold == undefined
                            ? 0
                            : dayInfo[0][selectedLocation?.locId].magnaLitersSold.toLocaleString()}
                        </span>
                      </small>

                      <small className="text-danger p-0 mx-1">
                        P:{" "}
                        <span>
                          {dayInfo[0][selectedLocation?.locId].premiumLitersSold == undefined
                            ? 0
                            : dayInfo[0][
                                selectedLocation?.locId
                              ].premiumLitersSold.toLocaleString()}
                        </span>
                      </small>

                      <small className="text-black p-0 mx-1">
                        D:{" "}
                        <span>
                          {dayInfo[0][selectedLocation?.locId].dieselLitersSold == undefined
                            ? 0
                            : dayInfo[0][selectedLocation?.locId].dieselLitersSold.toLocaleString()}
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
                <p className="m-0 text-center"> Utilidad</p>
                <div className="d-flex flex-row align-items-start justify-content-center">
                  <small className="text-success p-0 mx-1">
                    M:{" "}
                    <span>
                      ${" "}
                      {(
                        dayInfo[0][selectedLocation?.locId].magnaSalesIncome -
                        dayInfo[0][selectedLocation?.locId].magnaCost *
                          dayInfo[0][selectedLocation?.locId].magnaLitersSold
                      ).toLocaleString() || 0}
                    </span>
                  </small>

                  <small className="text-danger p-0 mx-1">
                    P:{" "}
                    <span>
                      ${" "}
                      {(
                        dayInfo[0][selectedLocation?.locId].premiumSalesIncome -
                        dayInfo[0][selectedLocation?.locId].premiumCost *
                          dayInfo[0][selectedLocation?.locId].premiumLitersSold
                      ).toLocaleString() || 0}
                    </span>
                  </small>

                  <small className="text-black p-0 mx-1">
                    D:{" "}
                    <span>
                      ${" "}
                      {dayInfo[0][selectedLocation?.locId].dieselSalesIncome == undefined ||
                      dayInfo[0][selectedLocation?.locId].dieselLitersSold == undefined ||
                      dayInfo[0][selectedLocation?.locId].dieselCost == undefined
                        ? 0
                        : (
                            dayInfo[0][selectedLocation?.locId].dieselSalesIncome -
                            dayInfo[0][selectedLocation?.locId].dieselCost *
                              dayInfo[0][selectedLocation?.locId].dieselLitersSold
                          ).toLocaleString() || 0}
                    </span>
                  </small>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // useEffect(() => {}, [data, change]);

  return (
    <div>
      <Modal centered show={showModal} onHide={() => setShowEventModal(false)} size="xl">
        <Modal.Header className="fs-4 fw-semi-bold d-flex align-items-center justify-content-between">
          <button className="btn btn-light me-2" onClick={() => shiftDay(-1)}>
            ◀
          </button>
          <div className="flex-grow-1 text-center">
            {daySelected.day} / {meses[daySelected.month]} / {daySelected.year} {" - "}
            {selectedLocation?.name || "Selecciona una estación"}
          </div>
          <button className="btn btn-light ms-2" onClick={() => shiftDay(1)}>
            ▶
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-column">
            <div className="d-flex flex-row">
              <div className="mb-3 mx-3">
                <label htmlFor="magnaCost" className="form-label text-success">
                  Costo de Gasolina Regular
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="magnaCost"
                  value={magnaCost}
                  onChange={(e) => setMagnaCost(e.target.value)}
                />
              </div>
              <div className="mb-3 mx-3">
                <label htmlFor="premiumCost" className="form-label text-danger">
                  Costo de Gasolina Premium
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="premiumCost"
                  value={premiumCost}
                  onChange={(e) => setPremiumCost(e.target.value)}
                />
              </div>

              <div className="mb-3 mx-3">
                <label htmlFor="dieselCost" className="form-label text-black">
                  Costo de Diesel
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="dieselCost"
                  value={dieselCost}
                  onChange={(e) => setDieselCost(e.target.value)}
                />
              </div>
            </div>

            <hr className="my-2" />
            <div className="d-flex align-items-center mx-3 mb-2">
              <input
                type="checkbox"
                id="bulkMode"
                className="form-check-input me-2 mt-0"
                checked={bulkMode}
                onChange={(e) => {
                  setBulkMode(e.target.checked);
                  if (!e.target.checked) setEndDate("");
                }}
              />
              <label htmlFor="bulkMode" className="form-label mb-0">
                Aplicar a un rango de fechas
              </label>
            </div>

            {bulkMode && (
              <div className="d-flex flex-row align-items-end mx-3">
                <div className="me-3">
                  <label className="form-label mb-1">Desde</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dayjs(daySelected.date).format("YYYY-MM-DD")}
                    disabled
                  />
                </div>
                <div>
                  <label className="form-label mb-1">Hasta</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    min={dayjs(daySelected.date).format("YYYY-MM-DD")}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                {endDate && (
                  <small className="ms-3 text-muted align-self-center">
                    {dayjs(endDate).diff(dayjs(daySelected.date), "day") + 1} días
                  </small>
                )}
              </div>
            )}

            <hr className="my-2" />
            <div className="mx-3">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <label className="form-label mb-0 fw-bold">
                  Clonar costos a otras estaciones
                </label>
                {otherLocations.length > 0 && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-link p-0 me-3"
                      onClick={() =>
                        setCloneTargets(otherLocations.map((loc) => loc.locId))
                      }
                    >
                      Seleccionar todas
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-link p-0"
                      onClick={() => setCloneTargets([])}
                    >
                      Limpiar
                    </button>
                  </div>
                )}
              </div>

              {!selectedLocation?.locId ? (
                <small className="text-muted">
                  Selecciona una estación origen para poder clonar.
                </small>
              ) : otherLocations.length === 0 ? (
                <small className="text-muted">
                  No hay otras estaciones disponibles para clonar.
                </small>
              ) : (
                <>
                  <small className="text-muted d-block mb-2">
                    Se aplicarán los costos mostrados arriba a las estaciones seleccionadas
                    {bulkMode && endDate ? " en el rango de fechas indicado." : " para este día."}
                  </small>
                  <div className="d-flex flex-wrap">
                    {otherLocations.map((loc) => (
                      <div
                        key={loc.locId}
                        className="form-check me-3 mb-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`clone-${loc.locId}`}
                          checked={cloneTargets.includes(loc.locId)}
                          onChange={() => toggleCloneTarget(loc.locId)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`clone-${loc.locId}`}
                        >
                          {loc.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex">
          {/* <Button variant="primary" onClick={() => console.log("s")}>
            Agregar Evento
          </Button> */}
          <button
            className="btn btn-outline-primary"
            disabled={cloning || loading || cloneTargets.length === 0}
            onClick={() => {
              cloneCostsToStations();
              setChange(!change);
            }}
          >
            {cloning
              ? "Clonando..."
              : `Clonar costos${
                  cloneTargets.length > 0 ? ` (${cloneTargets.length})` : ""
                }`}
          </button>
          <button
            className="btn btn-primary"
            disabled={loading || cloning}
            onClick={() => {
              updateGasCosts(daySelected.date);
              setChange(!change);
            }}
          >
            Guardar
          </button>
        </Modal.Footer>
      </Modal>
      <div
        className=""
        style={{
          display: "grid",
          gridTemplateColumns: "auto auto auto auto auto auto auto",
          gridAutoColumns: "100%",
          gridGap: "0px",
        }}
      >
        {month.map((row, i) => (
          <React.Fragment key={i}>
            {row.map((day, idx) => (
              <Day day={day} key={idx} rowIdx={i} />
            ))}
          </React.Fragment>
        ))}
      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
}
